import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {unlockScreen} from "../actions/appActions";

import LockScreen from "../components/LockScreen";
import { useLockScreenSelector } from "../hooks/useAppSelector";
import { withHooks } from "../hooks/withHooks";

function mapDispatchToProps(dispatch) {
  return {
    unlockScreen: bindActionCreators(unlockScreen, dispatch),
  };
}

const LockScreenContainer = withHooks(
  connect(null, mapDispatchToProps)(LockScreen),
  useLockScreenSelector
);

export default LockScreenContainer;
